<div class="approvals-search-filters">
    <!-- button for open filters -->
    <app-helpers-search-filters-menu 
        [filters]="filtersMenu"
        (chooseFilter)="onSelectFilter($event)"
    ></app-helpers-search-filters-menu>

    <!-- approvals filters -->
    
    <ng-container *ngIf="selectedFilter ==  'label'">
        <ng-container *ngIf="filterStatus && filterStatus.labels.status == F_STATUS.DONE; else labelsFLoading">
            <app-helpers-search-filters-labels-main 
                [available]="availableLabels"
                [applied]="appliedFilters" 
                (apply)="onApplyFilter($event)"
            ></app-helpers-search-filters-labels-main>
        </ng-container>
        <ng-template #labelsFLoading>

            <div *ngIf="filterStatus && filterStatus.labels.status == F_STATUS.LOADING; else labelsFManual">
                <ul class="filters-check-subsection loading-filters">
                    <li><core-helpers-box-loading></core-helpers-box-loading></li>
                </ul>
                
            </div>
            <ng-template #labelsFManual>
              <div class="filters-nav-menu load-filters">
                <div class="filters-nav">
                  <ul class="filters-check-subsection manual-load-filters">
                    <li><span class="filter-title" (click)="loadLabels($event)"> Load tags </span></li>
                </ul>
                </div>
                </div>
                
            </ng-template>
        </ng-template>
    </ng-container>
    
    <ng-container *ngIf="selectedFilter ==  'feedback_user'">
        <ng-container *ngIf="filterStatus && filterStatus.users.status == F_STATUS.DONE && availableUsers?.items?.length > 0; else usersFLoading">
            <app-helpers-search-filters-users-main  
                [available]="availableUsers"
                [applied]="appliedFilters" 
                (apply)="onApplyFilter($event)"
            ></app-helpers-search-filters-users-main>
        </ng-container>
        <ng-template #usersFLoading>

            <div *ngIf="filterStatus && filterStatus.users.status == F_STATUS.LOADING; else usersFManual">
                <ul class="filters-check-subsection loading-filters">
                    <li><core-helpers-box-loading></core-helpers-box-loading></li>
                </ul>
            </div>
            <ng-template #usersFManual>
                <div class="filters-nav-menu load-filters">
                  <div class="filters-nav">
                    <ul class="filters-check-subsection manual-load-filters">
                      <li>
                        <span class="filter-title" (click)="loadUsers($event)">Load recipients.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
        </ng-template>
    </ng-container>

</div>